import React from 'react';
import PropTypes from 'prop-types';
import { TextField, Alert } from '@mui/material';
import DescribedField from '../DescribedField';

/**
 * HeroBlockEditor — Editor do bloco Capa (Hero)
 * TODO 4.5
 *
 * Props:
 *   - value: { title, subtitle }
 *   - onChange: (patch) => void
 *   - context: { siteType, scope, availableProfessionals, ... }
 */
const HeroBlockEditor = ({ value = {}, onChange, context = {} }) => {
  const {
    title = '',
    subtitle = '',
  } = value;

  const patch = (field, val) => onChange({ ...value, [field]: val });

  return (
    <>
      <DescribedField
        label="Título"
        description="Aparece como primeiro texto da página. Use o nome do profissional, da clínica ou um título comercial (ex.: 'Consultório Dr. João Silva'). Máx. 80 caracteres."
      >
        <TextField
          fullWidth
          value={title}
          onChange={(e) => patch('title', e.target.value)}
          inputProps={{ maxLength: 80 }}
          placeholder="Ex.: Dr. João Silva"
          size="small"
        />
      </DescribedField>

      <DescribedField
        label="Subtítulo"
        description="Linha de apoio logo abaixo do título. Use para especialidade, slogan ou posicionamento (ex.: 'Dermatologia Clínica e Estética'). Máx. 140 caracteres."
      >
        <TextField
          fullWidth
          value={subtitle}
          onChange={(e) => patch('subtitle', e.target.value)}
          inputProps={{ maxLength: 140 }}
          placeholder="Ex.: Dermatologia Clínica e Estética"
          size="small"
        />
      </DescribedField>

      <Alert severity="info" icon={false} sx={{ mb: 2 }}>
        Avatar e formato são configurados na seção <strong>Identidade</strong>.
      </Alert>
    </>
  );
};

HeroBlockEditor.propTypes = {
  value: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
  }),
  onChange: PropTypes.func.isRequired,
  context: PropTypes.shape({
    siteType: PropTypes.string,
    scope: PropTypes.object,
    availableProfessionals: PropTypes.array,
    availablePlaces: PropTypes.array,
    availableSchedules: PropTypes.array,
    availableServices: PropTypes.array,
  }),
};

export default HeroBlockEditor;
